/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

function Tooltip({ anchorRef, text, visible }) {
    const [style, setStyle] = useState({});
    const tooltipRef = useRef(null);

    // eslint-disable-next-line
    useEffect(() => {
        if (anchorRef.current && tooltipRef.current && visible) {
            const rect = anchorRef.current.getBoundingClientRect();

            setStyle({
                position: "fixed",
                top: rect.top - 8,
                left: rect.left + rect.width / 2,
                transform: "translate(-50%, -100%)",
            });
        }
    }, [visible]);

    if (!visible) return null;

    return createPortal(
        <div
            ref={tooltipRef}
            style={style}
            className="
        z-[9999]
        whitespace-nowrap
        rounded-md
        bg-[#555]
        px-3 py-1.5
        text-[12px]
        text-white
        shadow-lg
      "
        >
            {text}
        </div>,
        document.body
    );
}

export default Tooltip;